import { Component } from '@angular/core';

@Component({
  selector: 'lib-input-base',
  templateUrl: './input-base.component.html',
  styleUrls: ['./input-base.component.scss'],
  standalone: true,
})
export class InputBaseComponent {}
